import React, { useEffect, useState } from "react";
import { useNavigate, Routes, Route } from "react-router-dom";
import "./App.css";

import Task from "./pages/Task/Task";
import Priority from "./pages/Priority/Priority";
import Report from "./pages/Report/Report";
import Team from "./pages/Team/Team";

import { useAuth } from "./pages/Login/useAuth";
import Layout from "./pages/Layout/Layout";
import Logout from "./pages/Layout/Logout";
import SessionExpire from "./pages/Layout/SessionExpire";
import Client from "./pages/Client/Client";
import Logs from "./pages/Logs/Logs";
import LogTime from "./pages/LogTime/LogTime";

function App() {
  const { isAuthenticated, signout } = useAuth();

  const [login, setLogin] = useState(isAuthenticated());

  let history = useNavigate();

  // Check if user is logged out in another tab
  useEffect(() => {
    const handleStorageChange = (e: any) => {
      if (e.key === "isAuthenticated" && e.newValue === "false") {
        setLogin(false); 
        history("/logout"); // Redirect to logout or login page
      }
    };

    window.addEventListener("storage", handleStorageChange);
    return () => {
      window.removeEventListener("storage", handleStorageChange);
    };
  }, [history]);

  //   // Handle login state and redirect to task
  //   useEffect(() => {
  //     if (login) {
  //       history("/task");
  //     }
  //   }, [login, history]);

  return (
    <Routes>
      <Route
        path="/"
        element={
          <Layout
            login={login}
            history={history}
            setLogin={setLogin}
            signout={signout}
          />
        }
      >
        <Route path="/team" element={<Team />} />
        <Route path="/task" element={<Task />} />
        <Route path="/task/:projectId" element={<Task />} />
        <Route path="/client" element={<Client />} />
        <Route path="/priority" element={<Priority />} />
        <Route path="/home" element={<Home />} />
        <Route path="/report" element={<Report />} />
        <Route path="/logs" element={<Logs />} />

        <Route path="/logTime" element={<LogTime />} />
        <Route path="/sprint" element={<EmptyCard />} />
        <Route path="/leave" element={<EmptyCard />} />
        <Route path="/admin" element={<EmptyCard />} />
      </Route>
      <Route path="/logout" element={<Logout setLogin={setLogin} />} />
      <Route path="/timeout" element={<Logout setLogin={setLogin} />} />
    </Routes>
  );
}

function Home() {
  return (
    <div>
      <h1>Welcome, Home</h1>
    </div>
  );
}

function EmptyCard() {
  return (
    <div className="task-top-table-separate">
      <div className="tsk-lists-wrap">
        <div className="tsk-lists ">
          <div className="tsk-lists empty-screen-wrap">
            <div className="card-ui">
              <div className="icon-block-wrap">
                {" "}
                <span className="tsk-icon material-icons-round">
                  ramen_dining
                </span>{" "}
              </div>
              <h3>Coming soon...</h3>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}

export default App;
